import { openBlock as l, createElementBlock as o, createElementVNode as t } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, e) {
  return l(), o("svg", r, [...e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      d: "M12 3c4.95 0 9 4.05 9 9s-4.05 9-9 9-9-4.05-9-9 4.05-9 9-9m0 1.8c-3.969 0-7.2 3.23-7.2 7.2s3.231 7.2 7.2 7.2 7.2-3.231 7.2-7.2-3.23-7.2-7.2-7.2m.77 3.086c1.322.228 1.837 1.277 1.953 1.6l-1.215.478c-.085-.25-.455-.957-1.462-.957-.539 0-1.392.265-1.392.993 0 .671.661.936 2.03 1.357C14.532 11.95 15 12.822 15 13.815c0 1.877-1.922 2.235-2.23 2.3V17h-1.54v-.922c-.477-.129-1.746-.55-2.23-2.114l1.277-.479c.046.158.446 1.494 1.846 1.494.715 0 1.524-.344 1.524-1.15 0-.686-.54-1.05-1.754-1.45-.847-.286-2.577-.743-2.578-2.364 0-.072.008-1.714 1.915-2.115V7h1.54z"
    }, null, -1)
  ])]);
}
const d = { render: n };
export {
  d as default,
  n as render
};
